export interface ProjectShortcutFolders {
  id?: number;
}

// to single object maping
export const mapProjectShortcutFolders = (
  data: any
): ProjectShortcutFolders => {
  if (!data) {
    throw new Error("Invalid Data");
  }
  const res: ProjectShortcutFolders = {
    id: data.id,
  };
  return res;
};

// maping list objects
export const mapProjectShortcutFolderss = (
  data: any[]
): ProjectShortcutFolders[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }
  return data.map(mapProjectShortcutFolders);
};
